import CompanySettingsHelper from '../../helpers/company/settings'
import { $t } from "@/i18n";

const validateChecklistUnfinished = (companyAccount, task_data) => {
    if (!CompanySettingsHelper.isEnabledChecklistMustBeCompletedToFinishTask(companyAccount)) {
        return false
    }

    if (task_data.checklist && (task_data.checklist.checked_count < task_data.checklist.items_count)) {
        return true
    }

    return false
}

const validateTitleRequired = (task_data) => {
    if (!task_data.title) {
        return true
    }

    return false
}

const validateTitleMaxLength = (task_data) => {
    if (typeof task_data.title === 'string' && task_data.title.length <= 140) {
        return false
    }

    return true
}

const validateClientRequired = (task_data, isTemplateTask) => {
    if (!task_data.client_id && !isTemplateTask) {
        return true
    }

    return false
}

const validateTimingRequired = (client, task_data, form_data = null) => {
    if (!client) {
        return false
    }

    if (!client.timing_required) {
        return false
    }

    if (task_data.estimation) {
        return false
    }

    if (form_data && form_data.time_entry) {
        return false
    }

    if (!task_data.tracked_time || task_data.tracked_time && Object.keys(task_data.tracked_time).length === 0) {
        return true
    }

    return false
}

const validateTopicRequiredError = (task_data, client) => {
    return client && client.topic_required && !task_data.topic_id
}

export default {
    validateSave: (task_data, client, isTemplateTask) => {
        const errors = {}
        let success = true

        if (validateTopicRequiredError(task_data, client)) {
            errors['topic_id'] = $t('Required field')
            success = false
        }

        if (validateTitleMaxLength(task_data)) {
            errors['title'] = $t('Max 140 characters')
            success = false
        }

        if (validateTitleRequired(task_data)) {
            errors['title'] = $t('Required field')
            success = false
        }

        if (validateClientRequired(task_data, isTemplateTask)) {
            errors['client_id'] = $t('Required field')
            success = false
        }

        return {
            success,
            errors
        }
    },
    validateToggleCompleted: (company, client, task_data, form_data = null) => {
        if (validateChecklistUnfinished(company, task_data)) {
            return {
                message: $t("Please complete the checklist"),
                details: $t('It is required to mark all checklist items as done'),
                success: false
            }
        }

        if (validateTimingRequired(client, task_data, form_data)) {
            return {
                message: $t("Please enter time spent"),
                details: $t('Inserting time is essential for this client')
            };
        }

        return {
            success: true
        }
    }
}